import { render, staticRenderFns } from "./setAlarm.vue?vue&type=template&id=e03c83d8&"
import script from "./setAlarm.vue?vue&type=script&lang=js&"
export * from "./setAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports